import { FunctionComponent } from "react";
import Mariusz from "../../assets/pictures/Mariusz/final.webp";

interface MainSectionProps {}

const MainSection: FunctionComponent<MainSectionProps> = () => {
  return (
    <div
      className="main-section"
      style={{
        overflow: "hidden",
      }}
    >
      <div className="content">
        <div className="text">
          <h1>Doświadczony Chirurg Dziecięcy - Profesjonalizm i Empatia</h1>
          <p>
            Jestem doświadczonym chirurgiem dziecięcym z ponad 30-letnią
            praktyką, specjalizującym się w opiece nad najmłodszymi pacjentami.
            Moje wieloletnie doświadczenie i zaangażowanie w pracę zapewniają
            najwyższy poziom opieki chirurgicznej.
          </p>
        </div>
        <img src={Mariusz} alt="doctor" />
      </div>
    </div>
  );
};

export default MainSection;
